import {token, queryOpenId, getBind} from "../api/Api";
import store from "../store"
import Constant from "./Constant";

export function getQueryString(name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  console.log(window.location.search);
  let r = window.location.search.substr(1).match(reg);  //获取url中"?"符后的字符串并正则匹配
  let context = "";
  if (r != null)
    context = r[2];
  reg = null;
  r = null;
  return context == null || context == "" || context == "undefined" ? "" : context;
}

export async function getToken(openId) {
  let res = await token({openId, termNo: Constant.TermInfo.termNo, termType: Constant.TermInfo.termType, resourceType: '3'})
  if (res.status !== 200) {
    console.log('get token 500')
    throw new Error('系统异常，请稍后再试');
  }
  store.commit('saveToken', res.data);
  return res.data;
}

export async function getOpenId() {
  let code = getQueryString('code');
  if (code === '') {
    console.log('code is empty')
    throw new Error('系统异常，请稍后再试');
  }
  let res = await queryOpenId({code});
  if (res.status !== 200) {
    console.log('get openId 500')
    throw new Error('系统异常，请稍后再试');
  }
  if(res.data === null || res.data === '' || res.data === undefined){
    console.log('openId is empty')
    throw new Error('系统异常，请稍后再试');
  }
  store.commit('setOpenId', res.data);
  return res.data;
}

export async function getPatientBind(accountType) {
  let res = await getBind(accountType);
  if (res.status !== 200) {
    console.log('get patient bind 500')
    throw new Error('系统异常，请稍后再试');
  }
  console.log('get patient result code is' + res.data.code);
  if (res.data.code === '0000') {
    let patientInfo = store.state.patientInfo;
    if(accountType === Constant.AccountType.OUT_PATIENT){
      patientInfo.cardNo = res.data.cardNo;
      patientInfo.cardType = res.data.cardType;
      patientInfo.name = res.data.name;
      patientInfo.cardTypeDesc = Constant.CardTypeDesc[parseInt(res.data.cardType) - 1];
      patientInfo.patientId = res.data.patientId;
      patientInfo.outPatientBalance = res.data.balance;
      patientInfo.idNo = res.data.idNo;
      store.commit("setPatientInfo", patientInfo);
    }
    let inhospitalPatientInfo = store.state.inhospitalPatientInfo;
    if(accountType === Constant.AccountType.IN_HOSPITAL) {
      inhospitalPatientInfo.cardNo = res.data.cardNo;
      inhospitalPatientInfo.hospitalNo = res.data.patientId;
      inhospitalPatientInfo.name = res.data.name;
      inhospitalPatientInfo.inHospitalBalance = res.data.balance;
      inhospitalPatientInfo.dept = res.data.deptName;
      inhospitalPatientInfo.bedNo = res.data.bedNo;
      inhospitalPatientInfo.visitId = res.data.visitId;
      inhospitalPatientInfo.idNo = res.data.idNo;
      store.commit("setInhospitalPatientInfo", inhospitalPatientInfo);
    }
    return {code: 0, message: '查询绑定关系成功'};
  }
  if (res.data.code === '1000') {
    return {code: 1, message: '未查询到绑定关系, 请进行就诊卡绑定'};
  }
  if (res.data.code === '1005') {
    return {code: 1, message: '绑定的卡已注销，请重新进行绑定'};
  }
  throw new Error('系统异常，请稍后再试');
}

export async function auth() {
  let openId = await getOpenId();
  await getToken(openId);
}